import { useCallback, useMemo } from 'react';
import { calculateProfitFromTakeProfit } from '../../../common/utils/calculations.util';

export const useCloseAtProfit = ({
  absoluteLimitOfInvestment,
  store,
  volume,
  symbolProperties,
}) => {
  const onChange = useCallback((value) => {
    if (value > 0) {
      store.setCloseAtProfitOf(Number(value));
    } else {
      store.setCloseAtProfitOf(0);
      store.setCloseAtProfit(false);
    }
  }, []);

  const onToggle = useCallback(() => {
    store.setCloseAtProfit(!store.closeAtProfit);
    if (store.closeAtProfit) {
      store.setCloseAtProfitOf(absoluteLimitOfInvestment.value);
    } else {
      store.setCloseAtProfitOf(0);
    }
  }, []);

  const value = useMemo(() => {
    if (store.takeProfitLevel) {
      const maxLost = calculateProfitFromTakeProfit({
        volume: volume.value,
        takeProfitLevel: store.takeProfitLevel,
        openPrice: store.openAtPriceOf,
        kRate: symbolProperties.kRate,
        contractSize: symbolProperties.contractSize,
        commission: symbolProperties.commission,
      });

      store.setCloseAtProfitOf(maxLost);

      return maxLost;
    }
    return store.closeAtProfitOf;
  }, [
    store.takeProfitLevel,
    volume.value,
    store.openAtPriceOf,
    store.closeAtProfit,
    store.closeAtProfitOf,
  ]);

  return {
    onChange,
    value,
    enabled: store.closeAtProfit && !store.takeProfitLevel,
    onToggle,
  };
};
